export const getLoaderStatus = state => state.shared.loader.isLoader;

export const getPopupState = state => state.shared.popup;

export const getWizardActiveStep = state => state.shared.wizard.activeStep;
